<template>
  <section class="app-bottom">
    <div class="container">
      <p class="pull-left">&copy; {{ $t('companyName') }} {{new Date().getFullYear()}}
        <a target="_blank" href="https://beian.miit.gov.cn" style="color: black">粤ICP备20058878号-1</a>
      </p>
      &nbsp&nbsp&nbsp&nbsp
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44532102445365" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img :src=policeimg style="float:left;"><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44532102445365号</p ></a>
    </div>
  </section>
</template>

<script>
import police from "@/assets/police.png";
export default {
  name: "Bottom",
  data(){
    return {
      policeimg:police,
    }
  }
}
</script>

<style scoped>
  .app-bottom {
    margin-top: 50px;
    /*background-color: red;*/
    height: 20px;
    text-align:center;
    /*position: fixed;*/
    bottom: 0;
    width: 100%;

    /*height: 20px;*/
    /*text-align:center;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*width: 100%;*/
  }
</style>



// WEBPACK FOOTER //
// src/layouts/components/Bottom.vue